<template>
  <div>
    <div class="img-container" ref="banner">
      <img src="/img/1-首页-banner.gif" alt="" />
      <div class="mask"></div>
      <div class="desc">
        <h1>{{ $t('home.banner_title') }}</h1>
        <div>{{ $t('home.banner_subtitle') }}</div>
        <div>
          <i class="el-icon-d-arrow-left arrow" @click="toNextPage"></i>
        </div>
      </div>
    </div>
    <div class="companyIntroduce w">
      <div class="title">{{ $t('home.company_title') }}</div>
      <div class="line"></div>
      <div class="introduce">
        <div
            class="description"
            data-aos="fade-right"
            data-aos-duration="3000"
            data-aos-delay="500"
        >
          <p>{{ $t('home.company_desc1') }}</p>
          <p>{{ $t('home.company_desc2') }}</p>
          <p>{{ $t('home.company_desc3') }}</p>
          <p>{{ $t('home.company_desc4') }}</p>
        </div>
        <div
            class="imgGather"
            data-aos="fade-left"
            data-aos-duration="3000"
            data-aos-delay="500"
        >
          <img src="/img/1首页-公司介绍-img1.jpg" alt="" />
          <img src="/img/1首页-公司介绍-img2.jpg" alt="" />
          <img src="/img/1首页-公司介绍-img3.jpg" alt="" />
          <img src="/img/1首页-公司介绍-img4.jpg" alt="" />
        </div>
      </div>
      <div class="msd-product">
        <div class="title">{{ $t('home.product_seriesTitle') }}</div>
        <div class="line line1"></div>
        <p style="margin-top: 25px;">{{ $t('home.product_seriesDesc') }}</p>
        <div class="product-list flex">
          <div
              v-for="item in imgList"
              :key="item.type"
              class="product"
              ref="product"
          >
            <div class="product-left">
              <div class="product-title">{{ item.title }}</div>
              <div class="product-desc">{{ item.desc }}</div>
              <div class="product-btn" @click="toPage(item.type)">{{ $t('home.product_more') }}</div>
            </div>
            <img
                :src="item.imgUrl"
                alt=""
                class="product-right"
                ref="img"
                @mouseenter="handleEnter"
                @mouseleave="handleLeave"
                @click="toPage(item.type)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { t } from '@/VueI18n'

export default {
  name: 'Home',

  data() {
    return {
      rootHeight: 0,
    }
  },
  computed: {
    imgList() {
      return [
        {
          type: 'hardware',
          title: this.$t('home.product_hardware_title'),
          desc: this.$t('home.product_hardware_desc'),
          imgUrl: require('/public/img/1首页产品图-五金.png'),
          y: 0,
        },
        {
          type: 'home',
          title: this.$t('home.product_home_title'),
          desc: this.$t('home.product_home_desc'),
          imgUrl: require('/public/img/1首页产品图-家居.png'),
          y: 0,
        },
        {
          type: 'cart',
          title: this.$t('home.product_cart_title'),
          desc: this.$t('home.product_cart_desc'),
          imgUrl: require('/public/img/1首页产品图-汽车.png'),
          y: 0,
        },
        {
          type: 'kitchenware',
          title: this.$t('home.product_kitchenware_title'),
          desc: this.$t('home.product_kitchenware_desc'),
          imgUrl: require('/public/img/1首页产品图—厨具.png'),
          y: 0,
        },
      ]
    }
  },
  mounted() {
    this.initialization()
    document.addEventListener('scroll', this.handleScroll, false)
  },
  methods: {
    initialization() {
      this.rootHeight = document.documentElement.clientHeight
    },
    handleEnter(e) {
      e.target.style.transform += 'scale(1.06)'
    },
    handleLeave(e) {
      e.target.style.transform = e.target.style.transform.split(' ')[0]
    },
    toPage(type) {
      this.$emit('update:currentIndex', 4)
      this.$router.push({ name: 'ProductDisplay', params: { type } })
    },
    handleScroll() {
      this.$refs.product.forEach((item, index) => {
        let productHeight = item.getBoundingClientRect().top
        if (productHeight <= -380) {
          this.$refs.img[index].style.transform = `translateY(200px)`
        } else if (productHeight > -380 && productHeight < this.rootHeight) {
          let distance =
              ((productHeight - this.imgList[index]['y']) * 200) /
              (this.rootHeight + 380)

          let y = this.$refs.img[index].style.transform.match(
              /\d+(\.\d+)?/
          )[0]
          let res = y - distance
          this.$refs.img[index].style.transform = `translateY(${res}px)`
        } else if (productHeight >= this.rootHeight) {
          this.$refs.img[index].style.transform = `translateY(0px)`
        }
        this.imgList[index]['y'] = productHeight
      })
    },
    toNextPage() {
      window.scrollTo(0, this.$refs.banner.clientHeight)
    },
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss" scoped>
.img-container {
  position: relative;
  font-size: 0;
  animation: enlarge 1s;
  min-width: 1440px;
  img {
    width: 100%;
  }
}
.mask {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(28, 41, 47, 0.3);
}
.desc {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #fff;
  text-align: center;
  z-index: 3;
  h1 {
    margin: 0;
    font-size: 110px;
    white-space: 5px;
  }
  div {
    margin-top: 20px;
    font-size: 70px;
  }
}
.arrow {
  transform: rotateZ(-90deg);
  cursor: pointer;
  animation: down 1s infinite;
  &:hover {
    animation: none;
  }
}
@keyframes down {
  0% {
    transform: translateY(0px) rotateZ(-90deg);
  }
  100% {
    transform: translateY(10px) rotateZ(-90deg);
  }
}
.companyIntroduce {
  padding-top: 90px;
}

.introduce {
  position: relative;
  margin-top: 52px;
  height: 624px;
  background-color: #f8f9fa;
}
.description {
  position: absolute;
  top: 95px;
  left: 40px;
  p {
    width: 666px;
    margin-bottom: 36px;
    line-height: 1.5;
    font-size: 18px;
    text-indent: 2em;
    text-align: justify;
  }
}

.imgGather {
  position: absolute;
  top: -40px;
  right: 40px;
  display: flex;
  flex-wrap: wrap;
  width: 600px;
  img {
    border: 1px solid transparent;
  }
}

.msd-product {
  position: relative;
  padding-top: 90px;
  text-align: center;
  padding-bottom: 34px;
  color: #333;
}
.product-list {
  margin-top: 30px;
  flex-wrap: wrap;
  justify-content: space-between;
  text-align: left;
}
.product {
  position: relative;
  margin-bottom: 56px;
  width: 692px;
  height: 450px;
  box-shadow: 0 0 20px #e6e9f0;
}
.product-left {
  position: absolute;
  top: 70px;
  bottom: 70px;
  left: 62px;
  width: 300px;
}
.product-title {
  font-size: 32px;
  font-weight: bold;
  white-space: nowrap;
}
.product-desc {
  margin-top: 44px;
  line-height: 2;
  font-size: 14px;
  color: #666;
  text-align: justify;
  height: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.product-btn {
  //position: absolute;
  //left: 0;
  //bottom: 0;
  //width: 110px;
  height: 48px;
  line-height: 48px;
  border-radius: 30px;
  text-align: center;
  font-size: 18px;
  color: #fff;
  background-color: #000;
  cursor: pointer;
  padding: 0 10px;
  display: inline-block;
  &:hover {
    opacity: 0.8;
  }
}
.product-right {
  position: absolute;
  right: -18px;
  top: 0px;
  height: 250px;
  transition: all 1s;
  cursor: pointer;
}
</style>